"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _collapse = _interopRequireDefault(require("antd/lib/collapse"));

var _SearchInput = _interopRequireDefault(require("./SearchInput"));

require("./searchPanel.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Panel
} = _collapse.default;

class SearchPanel extends _react.Component {
  render() {
    const {
      extra,
      filters,
      searchChangeHandler,
      searchSubmitHandler,
      searchTerm
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-search-panel"
    }, /*#__PURE__*/_react.default.createElement(_collapse.default, {
      defaultActiveKey: ['search'],
      expandIconPosition: "right"
    }, /*#__PURE__*/_react.default.createElement(Panel, {
      key: "search",
      header: "Search Criteria",
      extra: extra
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-search-panel-input-wrapper"
    }, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
      onChangeHandler: searchChangeHandler,
      onSubmitHandler: searchSubmitHandler,
      value: searchTerm
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-search-panel-filters-wrapper"
    }, filters.map((filter, index) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: `hmp-search-panel-filter-wrapper-${index}`,
        className: "hmp-search-panel-filter-wrapper"
      }, filter);
    })))));
  }

}

var _default = SearchPanel;
exports.default = _default;